import script from "./AdminMembersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminMembersPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminMembersPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__